import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';
import { RoutingProfileService } from '../../../../../app/services/vehicle-routing-profile.service';
import { RoutingProfileModel } from 'src/app/_models/profilews/profilews';
import { Route } from 'src/app/_models/view/route';
import { RouteService } from 'src/app/services/route.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AlertService } from 'src/app/auth/services/alert.service';
import { SubscriptionManager } from 'src/app/_helpers/subscription-manager';
import { Router } from '@angular/router';

@Component({
  selector: 'route-panel-profile-list',
  templateUrl: './profile-list.component.html',
  styleUrls: ['../route.component.scss'],
})
export class RoutePanelProfileListComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @Input() route: Route;
  profiles: RoutingProfileModel[] = [];
  profileId$: Observable<number>;
  private sm = new SubscriptionManager();
  isOpen: boolean;
  profileName: string;
  currentProfileId: number;
  customProfiles: RoutingProfileModel[] = [];
  defaultProfiles: RoutingProfileModel[] = [];
  constructor(
    private alertService: AlertService,
    private profileService: RoutingProfileService,
    private routeService: RouteService,
    private ref: ChangeDetectorRef,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isOpen = false;
    this.retrieveProfiles();
  }
  ngAfterViewInit(): void {
    if (this.route.isLegacy && !this.route.isAcceptLegacy) {
      this.isOpen = true;
    }
    this.ref.detectChanges();
  }
  navigateToCreateProfile() {
    this.router.navigate(['/routeProfiles/list'], {
      state: { id: 'createprofile' },
    });
  }
  retrieveProfiles() {
    this.sm.manage = this.profileService.profilesLoaded$.subscribe(
      (profileLoaded) => {
        if (this.profileService.hasProfiles()) {
          this.profiles = this.profileService.getProfiles();
          this.customProfiles = this.profiles.filter(
            (pf) => pf.routingProfileId > 0
          );
          this.defaultProfiles = this.profiles.filter(
            (pf) => pf.routingProfileId <= 0
          );

          this.profileId$ = this.routeService.getRoute(this.route.id).pipe(
            map((route) => {
              let id: number;
              const isProfileAvailable = this.profiles.some(
                (pf) => pf.routingProfileId === route?.profileId
              );
              if (route?.profileId && isProfileAvailable) {
                id = route.profileId;
              } else {
                id = this.getActiveProfileId(this.profiles);
                this.routeService.setRoutingProfile(this.route.id, id);
              }
              this.profileName = this.profiles.find(
                (profile) => profile.routingProfileId === id
              )?.name;
              return id;
            })
          );
        } else {
          // If service is too slow, then what ? // Todo-yz
          // Should not happen because the app retrieves routing profiles when map init.
          this.alertService.error(
            'Please try to login again to get routing profiles.'
          );
        }
      }
    );
    this.ref.detectChanges();
  }

  getActiveProfileId(profiles: RoutingProfileModel[]): number {
    const id = this.profileService.getActiveDefaultProfileId(profiles);
    return id;
  }

  changeProfile(p: RoutingProfileModel) {
    if (this.isOpen) {
      this.routeService.updateLegacyProfileShowInfo(this.route.id);
      this.isOpen = false;
    }
    this.routeService.setRoutingProfile(this.route.id, p.routingProfileId);
  }
  popOverClose() {
    this.routeService.updateLegacyProfileShowInfo(this.route.id);
    this.isOpen = false;
  }

  ngOnDestroy(): void {
    this.sm.unsubscribe();
  }
}
